import { AsyncPipe, PercentPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { isNumber } from 'lodash-es';
import { BehaviorSubject } from 'rxjs';

import { IconComponent } from '@shared/components/icon/icon.component';
import { Utils } from '@shared/utils/utils';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IconComponent, AsyncPipe, PercentPipe],
  selector: 'aux-percent-indicator',
  templateUrl: './percent-indicator.component.html',
})
export class PercentIndicatorComponent implements OnChanges {
  formattedValue$ = new BehaviorSubject(0);
  isValuePositive = false;
  @Input() value!: number;
  zeroHyphen = Utils.zeroHyphen;

  ngOnChanges(changes: SimpleChanges): void {
    const value = changes.value.currentValue;

    if (isNumber(value)) {
      this.isValuePositive = value >= 0;
      const formattedValue = Math.abs(value);

      this.formattedValue$.next(formattedValue);
    }
  }
}
